module.exports = __webpack_public_path__ + "static/media/trusted-fssai.7f593c1c.png";